import { render, staticRenderFns } from "./CallOrder.vue?vue&type=template&id=130a78b6&"
import script from "./CallOrder.vue?vue&type=script&lang=js&"
export * from "./CallOrder.vue?vue&type=script&lang=js&"
import style0 from "./CallOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports